<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :spa="24">
				<el-card class="box-card">
					<h4 class="title">参数信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">

						<el-form-item label="标题" prop="title">
							<el-input v-model="form.title" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="排列顺序" prop="sorts">
							<el-input v-model="form.sorts" style="width: 30%;"></el-input>
						</el-form-item>
						<el-form-item label="二维码">
						<el-upload action=" "  drag list-type="picture-card" :limit="1"    :show-file-list="false"
						 :file-list="ewmList"  :before-upload="beforePic" >
							  <img v-if="form.ewm" :src="settings.apiBaseImg+form.ewm" class="avatar">
							  
							  <i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
							  <br />
							  <span class="uploadTip">将图片拖到此处，或点击上传</span>
						</el-upload>
						</el-form-item>
						<el-form-item label="LOGO" prop="logo">
							<el-upload action=""  drag list-type="picture-card" :limit="1"    :show-file-list="false"
							 :file-list="fileList"  :before-upload="beforePics" >
								  <img v-if="form.logo" :src="settings.apiBaseImg+form.logo" class="avatar">
								  <i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
								  <br />
								  <span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="简介" prop="desc">
							<el-input type="textarea" v-model="form.desc" style="width:30%" rows="3"></el-input>
						</el-form-item>
						<el-form-item label="详情" prop="detail">
						<!-- 	<editor id="editor_id" height="500px" width="700px" :content.sync="editorText"

							           :loadStyleMode="false"
							          ></editor> -->
									  <editor v-model="form.detail" :isClear="isClear" @change="change"></editor>
						</el-form-item>
						<el-form-item>
							<input type="button" @click="onSubmit('form')" class="submit" value="提交">
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	import files from '../../../components/picFile.vue'
	import E from "wangeditor";
	import Editor from '../../../components/tinymce.vue'
	export default {
		components: {
			files,
			Editor
		},
		data() {
			return {
				form: {
					sorts: '',
					title: '',
					ewm: '',
					logo: '',
					desc: '',
					detail: ''
				},
				isClear: false,
				rules: {
					logo: [{
						required: true,
						message: '请输入LOGO',
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					sorts: [{
						required: true,
						message: '请输入排列顺序',
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请输入简介',
						trigger: 'blur'
					}],
					detail: [{
						required: true,
						message: '请输入详情',
						trigger: 'blur'
					}],

				},
				fileList: [],
				dialogVisible: false,
				ewmList:[],
				editorText: '', // 双向同步的变量
			}
		},
		created() {
			if (this.$route.query.iden == 'update') {
			var list = this.$route.query.rows
			this.form.title = list.title
			this.form.sorts = list.sort
			this.form.ewm = list.qrcode
			this.form.logo = list.logo
			this.form.desc = list.description
			this.form.detail = list.content
			}
		},
		methods: {
			//添加提交
			onSubmit(formName) {
				var obj = this;
				if(this.$route.query.iden == 'add'){
					this.$refs[formName].validate((valid) => {
						if (valid) {
							obj.$http({
								method: 'post',
								url: 'api/v1/application/add',
								data: {
									title:this.form.title,
									sort: this.form.sorts,
									qrcode: this.form.ewm,
									logo: this.form.logo,
									description: this.form.desc,
									content: this.form.detail
								},
							}).then((res) => {
								if (res.data.status == 200) {
									obj.$message.success('添加成功')
									this.$router.push({
										path: '/home/bullet'
									})
								} else {
									obj.$message.error(res.data.message)
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				}else{
					this.updateSubmit(formName)
				}
			
			},
			updateSubmit(formName){
				var obj = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						obj.$http({
							method: 'post',
							url: 'api/v1/application/update',
							data: {
								id:this.$route.query.rows.id,
								title:this.form.title,
								sort: this.form.sorts,
								qrcode: this.form.ewm,
								logo: this.form.logo,
								description: this.form.desc,
								content: this.form.detail
							},
						}).then((res) => {
							if (res.data.status == 200) {
								obj.$message.success('添加成功')
								this.$router.push({
									path: '/home/bullet'
								})
							} else {
								obj.$message.error(res.data.message)
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			change(val) {
			},
			//上传图片之前调取接口
			beforePic(file, fileList) {
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/application/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.form.ewm = res.data.data.url
						obj.$message.success(res.data.message)
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//上传LOGO图片之前调取接口
			beforePics(file, fileList) {
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/application/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.form.logo = res.data.data.url
						obj.$message.success(res.data.message)
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 40px;
	}

	/deep/ .el-input__inner {
		height: 30px;
	}

	.picTip {

		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/bullet/bulletUpdate.vue